import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import s from '../../styles/corporate/Corporate.module.css';
import { BUSINESS } from './data';

const no = (i) => `0${i + 1}`;

/** 사업영역 — 왼쪽 목록을 고르면 오른쪽 카드가 바뀐다 */
const CorpBusiness = ({ onNavigate }) => {
  const [active, setActive] = useState(0);
  const cur = BUSINESS[active];
  const isRoute = cur.href.startsWith('/');

  return (
    <section className={`${s.wrap} ${s.section}`} id="business">
      <div className={s.bizHead}>
        <h2 className={`${s.h2} ${s.reveal}`}>
          기술로 연결하는
          <br />더 넓은 가능성
        </h2>
        <p className={`${s.lead} ${s.reveal}`} data-delay="100">
          AI·데이터·플랫폼·기업 솔루션을 바탕으로 기업의 운영 효율과 새로운 협력 기회를 높입니다.
        </p>
      </div>

      <div className={s.bizGrid}>
        <div className={s.bizList}>
          {BUSINESS.map((item, i) => (
            <button
              type="button"
              key={item.title}
              className={`${s.bizItem} ${i === active ? s.bizItemOn : ''}`}
              onMouseEnter={() => setActive(i)}
              onFocus={() => setActive(i)}
              onClick={() => setActive(i)}
              aria-pressed={i === active}
            >
              <span className={s.mono} translate="no">
                {no(i)}
              </span>
              <span className={s.bizItemTitle}>{item.title}</span>
              <span className={s.bizArrow} aria-hidden="true">
                →
              </span>
            </button>
          ))}
        </div>

        <div className={s.bizCard}>
          <div className={s.bizCardNo} aria-hidden="true" translate="no">
            {no(active)}
          </div>
          <div className={s.mono} translate="no">
            {cur.tag}
          </div>
          <div className={s.bizCardBody}>
            <div className={s.bizCardTitle}>{cur.title}</div>
            <p className={s.bizCardText}>{cur.body}</p>
            {isRoute ? (
              <Link className={s.bizCardCta} to={cur.href}>
                {cur.cta}
              </Link>
            ) : (
              <button
                type="button"
                className={s.bizCardCta}
                onClick={() => onNavigate(cur.href.slice(1))}
              >
                {cur.cta}
              </button>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CorpBusiness;
